import { render, staticRenderFns } from "./CryptoDetails.vue?vue&type=template&id=5cdf8838&scoped=true"
import script from "./CryptoDetails.vue?vue&type=script&lang=js"
export * from "./CryptoDetails.vue?vue&type=script&lang=js"
import style0 from "./CryptoDetails.vue?vue&type=style&index=0&id=5cdf8838&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdf8838",
  null
  
)

export default component.exports